import { render, staticRenderFns } from "./DeliveryByChannel.vue?vue&type=template&id=69b273d4"
import script from "./DeliveryByChannel.vue?vue&type=script&lang=js"
export * from "./DeliveryByChannel.vue?vue&type=script&lang=js"
import style0 from "./DeliveryByChannel.vue?vue&type=style&index=0&id=69b273d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports